import { render, staticRenderFns } from "./NeedlesHeads.vue?vue&type=template&id=643fd0ca&"
import script from "./NeedlesHeads.vue?vue&type=script&lang=js&"
export * from "./NeedlesHeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports